import axios from "axios";
import { getShareableLink } from "consts";
import { BACKEND_URL } from "consts";

export function fetchMedia(id: number | string, token: string) {
  const url = getShareableLink(id, token);
  return axios.post(url, {
    fields: [
      "pg_media_id",
      "name",
      "versions",
      "accessible_from",
      "accessible_until",
      "type",
      "user_accessible",
      "tags",
      "original_url",
      "compressed_url",
      "thumbnail_url",
      "has_multiple_versions",
      "duration",
      "sprite_url",
      "comment_count",
      "version_count",
      "collab_status",
      "label_id",
      "is_private",
      "sku",
      "product_urls",
      "skus",
      "link_id",
      "integration_url",
      "proxy_large",
      "proxy_medium",
      "proxy_small",
    ],
  });
}

export function fetchMediaById(id: number) {
  return axios.get(BACKEND_URL + `/media/details/${id}`);
}
